<fieldset
  class="ais-RefinementList toggleWidget"
  *ngIf="state?.value?.onFacetValue?.count > 0 && (!isdealsEligible || currentDeal?.active)"
  [ngClass]="{'toggleWidget--sustainable': isDirectShipping || isLocalCountries}"
>
  <div>
    <!-- this div is here to simulate the ng-ais-header container -->
    <button
      class="ais-RefinementList-header ais-header toggleWidget__header"
      [ngClass]="{
        'ais-RefinementList-header--closed': !showRefinementBody,
        'ais-RefinementList-header--shorter': isDirectShipping || isLocalCountries
      }"
      (click)="toggleShowBody()"
      [attr.aria-expanded]="showRefinementBody"
    >
      <legend *ngIf="options.label === 'DELIVERY_OPTS.EXPRESS'" i18n="@@DELIVERY_OPTS.EXPRESS">Express Delivery</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.DS'" i18n="@@CATALOG.FILTERS.DS">Direct Shipping</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.LOCAL_COUNTRIES'">{{ marketingFilterLocal?.title }}</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.DEALS_ELIGIBLE'">{{ dealsName }}</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.OFFICIALSTORE'" i18n="@@PRODUCT.DESCRIPTION.BRAND_STORE">
        Brand Store
      </legend>
    </button>
  </div>
  <div
    class="ais-RefinementList-body ais-body toggleWidget__listContainer"
    [ngStyle]="{display: showRefinementBody ? 'block' : 'none'}"
  >
    <ul class="ais-RefinementList-list">
      <li *ngIf="state && state.value && state.value.onFacetValue">
        <input
          id="toggle__{{ state.value.name + '_on' }}"
          class="vc-checkbox__input filters_checkbox_input toggleWidget__input"
          type="checkbox"
          (change)="refineToggle($event, state.value)"
          [attr.checked]="state.value.onFacetValue.isRefined ? 'checked' : null"
        />
        <!-- LABELS -->
        <ng-container [ngSwitch]="state?.value?.onFacetValue?.name">
          <!-- EXPRES DELIVERY -->
          <label
            *ngSwitchCase="'stock_on'"
            for="toggle__{{ state.value?.name + '_on' }}"
            class="vc-checkbox__label filters_checkbox_label toggleWidget__label"
          >
            <a *ngIf="seoUrl; else stockLabel" [href]="seoUrl">
              <ng-template *ngTemplateOutlet="stockLabel"></ng-template>
            </a>
            <ng-template #stockLabel i18n="@@CATALOG.FILTERS.STOCK_24">
              Items shipped within 24 hours
            </ng-template>
            <span class="filters_checkbox_label_count">({{ state.value.onFacetValue.count }})</span>
          </label>

          <!-- DIRECT SHIPPING -->
          <label
            *ngSwitchCase="'dsEligibleCountries_on'"
            for="toggle__{{ state.value?.name + '_on' }}"
            class="vc-checkbox__label filters_checkbox_label toggleWidget__label"
          >
            <a *ngIf="seoUrl; else dsLabel" [href]="seoUrl">
              <ng-template *ngTemplateOutlet="dsLabel"></ng-template>
            </a>
            <ng-template #dsLabel>
              <ng-container i18n="@@REGULAR_FILTER_DS.SUSTAINABLE_LEAF.TEXT">
                Cut your item’s journey in half to save on CO2 and costs
              </ng-container>
            </ng-template>
            <span class="filters_checkbox_label_count">({{ state.value.onFacetValue.count }})</span>
          </label>

          <!-- LOCAL COUNTRIES -->
          <label
            *ngSwitchCase="'localCountries_on'"
            for="toggle__{{ state?.value?.name + '_on' }}"
            class="vc-checkbox__label filters_checkbox_label toggleWidget__label"
          >
            <a *ngIf="seoUrl; else localLabel" [href]="seoUrl">
              <ng-template *ngTemplateOutlet="localLabel"></ng-template>
            </a>
            <ng-template #localLabel>
              <span i18n="@@REGULAR_FILTER_LOCAL.SUSTAINABLE_LEAF.TEXT">
                Buy in your region for shorter shipping distances</span
              >
            </ng-template>
            <span class="filters_checkbox_label_count">({{ state?.value?.onFacetValue?.count }})</span>
          </label>

          <!-- DEALS ELIGIBLE -->
          <label
            *ngSwitchCase="'editorPicks.dealEligible_on'"
            for="toggle__{{ state?.value?.name + '_on' }}"
            class="vc-checkbox__label filters_checkbox_label toggleWidget__label"
          >
            <a *ngIf="seoUrl; else dealLabel" [href]="seoUrl">
              <ng-template *ngTemplateOutlet="dealLabel"></ng-template>
            </a>
            <ng-template #dealLabel>
              <span i18n="@@CATALOG.FILTERS.DEALS_LABEL"> Show {{ dealsName }}</span>
            </ng-template>
            <span class="filters_checkbox_label_count">({{ state?.value?.onFacetValue?.count }})</span>
          </label>

          <!-- BRAND STORE BADGE -->
          <label
            *ngSwitchCase="'seller.isOfficialStore_on'"
            for="toggle__{{ state.value?.name + '_on' }}"
            class="vc-checkbox__label filters_checkbox_label"
          >
            <a *ngIf="seoUrl; else brandLabel" [href]="seoUrl">
              <ng-template *ngTemplateOutlet="brandLabel"></ng-template>
            </a>
            <ng-template #brandLabel i18n="@@CATALOG.FILTERS.BS_LABEL">
              Display Brand Store items
            </ng-template>
            <span class="filters_checkbox_label_count">({{ state.value.onFacetValue.count }})</span>
          </label>
        </ng-container>
      </li>
    </ul>
  </div>
  <vc-catalog-sustainable
    *ngIf="isDirectShipping || isLocalCountries"
    [isMobile]="isMobile"
    [type]="options.facet"
    [localFilterName]="marketingFilterLocal?.title"
  ></vc-catalog-sustainable>
</fieldset>
